<template>
<div>
    <div class="body intro" id="login-main">
        <div class="wrap">
            <h1 class="mb-20"><img v-if="logo !== ''" :src="logo" alt="company logo"></h1>
            <div class="txt-center">
                <h2>{{title}}</h2>
                <p v-if="code === 'p'" class="preline">
                    신청내역확인 탭에서 로그인 하시면 신청하신 내역을 확인하실 수 있습니다.
                </p>
                <span v-if="code === 'p'" class="mt-20 font-13 dp-block">신청 기간 : {{sugangStartDate.slice(0, 10)}} ~ {{sugangEndDate.slice(0, 10)}}</span>
            </div>
            <div class="box-password">
                <div class="password-box">
                    <div v-if="validCheck === 'Y'" class="password-con">
                        <h3 v-if="code === 'p'">비밀번호 재설정</h3>
                        <p v-if="code === 'p'" class="font-13">
                            비밀번호 재설정을 위해 새로운 비밀번호를 입력해 주세요. <br>
                            비밀번호는 영문 + 숫자포함 8자 이상 12자 이하로 입력해 주세요.
                        </p>
                        <h3 v-if="code === 'l'">계정 확인이 완료되었습니다.</h3>
                        <p v-if="code === 'l'" class="font-13">
                            비밀번호 재설정 후 다시 로그인해 주세요. <br>
                            비밀번호는 영문 + 숫자포함 8자 이상 12자 이하로 입력해 주세요.
                        </p>
                        <div class="login-input">
                            <label for="" class="dp-block">
                                <input type="text" v-model="email" class="w-100per mb-10" :placeholder="email" disabled>
                            </label>
                            <label for="" class="dp-block">
                                <input type="password" v-model="password" placeholder="비밀번호를 입력해 주세요." class="w-100per mb-10">
                            </label>
                            <!-- 입력오류 시 노출 -->
                            <!-- <p class="txt-red">비밀번호는 6자 이상 12자 이하로 입력해 주세요.</p> -->
                            <button @click="fixPW()">비밀번호 재설정하기</button>
                        </div>
                        <!-- <div class="contact">
                            <b>Access Code & 문의</b>
                            <button class="float-right" @click="openModal('qna')" data-toggle="modal" data-target="#hq-contact">1:1 문의하기</button>
                        </div>
                        <div class="manager-wrap">
                            <p>Access Code는 수강 신청 안내문 mail 혹은 공지에서 확인이 가능하며,
                                확인이 어려울 시 아래의 매니저에게 문의 주시길 바랍니다.
                            </p>
                            <p v-for="(item, index) of qaAdminInfo" :key="index">{{item}}</p>
                        </div> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
    <qna-modal v-if="isQnaModalOpened" @close="closeModal()"></qna-modal>
</div>
</template>

<script>
import {
    EmptyCheck,
    EmailFormatCheck
} from '@/utils/validation.js'
import FindpwModal from '@/components/login/findPWModal.vue'
import QnaModal from '@/components/qnaModal.vue'
export default {
    components: {
        FindpwModal,
        QnaModal
    },
    data: () => ({
        email: '',
        password: '',

        isFindPWModalOpened: false, // 비밀번호 찾기 팝업 on/off
        isQnaModalOpened: false, // 1:1 문의 팝업 on/off
        isOnClass: true, // 수강신청 가능 기간인지 여부
        isExpect: true, // 곧 수강신청 예정이 있는지 여부
        isValidAccess: true, // Access Code가 유효한지 여부
        isValidAuth: true, //  이메일, 비밀번호가 유효한지 여부

        infoMessage: '', // Notice 내용
        logo: '', // 회사 로고 url
        main: '', // 메인 배경 url
        pageIdx: '', // 페이지 idx (itm_main_page_idx와 같음)
        pointColor: 'Blue', // 메뉴와 버튼 색깔
        qaAdmin: '', // hq 매니저
        qaAdminInfo: '', // hq 매니저 정보
        sugangStartDate: '2020-01-01 00:00', // 수강신청 시작 날짜
        sugangEndDate: '2020-12-30 00:00', // 수강신청 종료 날짜
        title: '', // 프로그램명 타이틀
        validCheck: 'Y',
        pageIdx : -1,
        isSend: false,
        code: 'p',
    }),

    watch: {
        tabType() {
            this.reset()
        }
    },

    mounted() {
        // if (sessionStorage.getItem('fixPWEmail')) {
        //     this.email = sessionStorage.getItem('fixPWEmail')
        // } else {
        //     alert('제대로 된 경로로 진입하지 않아\n로그인 화면으로 돌아갑니다')
        //     this.$router.push('/user/login')
        // }

        this.axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*'
        this.axios.defaults.headers.common['Access-Control-Allow-Methods'] = 'GET,PUT,POST,DELETE,OPTIONS'
        this.axios.defaults.headers.common['Access-Control-Allow-Headers'] = 'Content-Type, Authorization, Content-Length, X-Requested-With'
        // TODO: companyCode는 db itm_sugang_main 테이블에 company_code 참조 추후에 매핑필요
/* 
        var companyCode = 'ehddkeo'

        console.log('this.$route.params', this.$route.params)

        if (localStorage.getItem('companyCode')) {
            companyCode = localStorage.getItem('companyCode')
            sessionStorage.setItem('companyCode', companyCode)
        } else {
            alert('세션이 만료되었으므로 로그인 페이지로 이동합니다.')
        } */
        

        this.email = this.$route.params.email.substr(0, this.$route.params.email.indexOf("/"))
        this.pageIdx = this.$route.params.email.substring(this.$route.params.email.indexOf("^")+1)
        this.code = this.$route.params.code
        
        let companyCode = this.$route.params.companycode
        sessionStorage.setItem('companyCode', companyCode)

        let passwordResetKey = this.$route.params.email
        let params = {
            passwordResetKey: passwordResetKey
        }

        this.axios.get(this.axios.root + this.axios.port + `/user/password-key`, {
            params: params })
            .then(res => {
                // console.log('res', res)
                if (res.data.err === 0) {
                    this.validCheck = 'Y'
                } else {
                    alert("유효시간이 만료되어 접근할 수 없습니다.");
                    this.email = ''
                    this.validCheck = 'N'
                }
            })
        
        //this.email = localStorage.getItem('authEmail')

        // var params = {
        //     companyCode: companyCode
        // }

        let params2 = new URLSearchParams()
        params2.append('companyCode', companyCode)
        this.axios.get(this.axios.root + this.axios.port + `/user/main/${companyCode}`, params2)
            .then(res => {
                // console.log('res', res)
                if (res.data.err === 0) {
                    for (var item of Object.keys(res.data)) {
                        if (typeof this[item] !== 'undefined') {
                            this[item] = res.data[item]
                            // 배경 이미지 변경
                            if (item === 'main') {
                                document.getElementById("login-main").style.background = `url(${this.main}) no-repeat center`;
                                document.getElementById("login-main").style['background-size'] = 'cover'
                            }

                            if (item === 'pageIdx') {
                                sessionStorage.setItem('pageIdx', res.data[item])
                            }
                        }
                    }
                    if (this.qaAdminInfo !== '') {
                        this.qaAdminInfo = this.qaAdminInfo.split('^')
                    }
                } else {
                    alert(res.data.result)
                }
            })
            
    },

    methods: {

        // 입력한 이메일로 비밀번호 재설정 메일 발송
        sendEmail() {
            if (!EmptyCheck(this.email, '이메일을')) {
                return false
            }

            if (!EmailFormatCheck(this.email)) {
                return false
            }

            var pageIdx = this.pageIdx
            var params = {
                code: 'password_email',
                id: this.email,
                pageIdx: pageIdx
            }

            this.axios.get(this.axios.root + this.axios.port + `/user/password-email/${pageIdx}`, {
                    params: params
                })
                .then(res => {
                    this.isSend = true
                    // console.log('res', res)
                    sessionStorage.setItem('fixPWEmail', this.email)
                    localStorage.setItem('authEmail', this.email)
                    alert('발송 되었습니다.')
                }).catch(err => {
                    alert('수강신청 내역이 없는 E-mail입니다.')
                    // console.log(err)
                    // alert(err)
                })

        },

        fixPW() {

            if (this.password.trim() === '') {
                alert('비밀번호를 입력하세요.')
                return false
            }

            var passRegex = /^[A-Za-z0-9+]{8,12}$/
            if (!passRegex.exec(this.password)) {
                alert('비밀번호 형식은 영문 + 숫자포함 8~12자리로 해주세요.\n※ 특수문자 불가')
                return false
            }

            // if (this.password.length < 6 || this.password.length > 12) {
            //     alert('비밀번호는 영어+숫자 6자 이상 12자 이하로 입력해 주세요.')
            //     return false
            // }

            var params = new URLSearchParams()

            params.append('id', this.email)
            params.append('newPassword', this.password)
          
            params.append('passwordResetKey',this.$route.params.email)
            // var params = {
            //     id: this.email,
            //     newPassword: this.password
            // }

            this.axios.put(this.axios.root + this.axios.port + '/user/password-reset', params)
                // this.axios.put(this.axios.root + this.axios.port + '/user/password-reset', {
                //         params: params
                //     })
                .then(res => {
                    // console.log('res', res)
                    if (res.data.err === 0) {
                        alert('비밀번호가 변경되었습니다.\n로그인 페이지로 이동합니다.')
                        this.$router.push('/user/login')
                    } else {
                        alert(res.data.result)
                    }
                }).catch(err => {
                    // console.log(err)
                    alert(err)
                })
        },
        // 탭 변경시 입력값 초기화
        reset() {
            this.email = ''
            this.accessCode = ''
            this.password = ''
        },

        // 모달 열기
        openModal(type) {
            if (type === 'findPW') {
                this.isFindPWModalOpened = true
            } else if (type === 'qna') {
                this.isQnaModalOpened = true
            }
        },

        // 모달 닫기
        closeModal() {
            if (this.isFindPWModalOpened) {
                this.isFindPWModalOpened = false
            } else if (this.isQnaModalOpened) {
                this.isQnaModalOpened = false
            }
        },

    }
}
</script>
